import { makeStyles } from '@material-ui/core/styles';

export const useMotiveMobileStyles = makeStyles(() => ({
  title: {
    fontSize: 14,
    fontWeight: 600,
  },
  link: {
    textDecoration: 'none',
    color: 'black',
  },
  boxMotive: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #BCBCBC',
  },
}));
